import { Skeleton } from 'antd';

export function FormSkeleton() {
  return (
    <div className='w-full max-w-3xl p-6 sm:p-10 bg-wl-background rounded-xl shadow-sm box-shadow-sm animate-pulse grid gap-6'>
      {/* Title placeholder */}
      <Skeleton.Input
        active
        size='default'
        className='w-28 rounded-lg dark:bg-gray-200'
      />

      {/* Two columns rows */}
      <div className='grid gap-4 sm:grid-cols-2'>
        <Skeleton.Input
          active
          size='large'
          className='w-full rounded-lg dark:bg-gray-200'
        />
        <Skeleton.Input
          active
          size='large'
          className='w-full rounded-lg dark:bg-gray-200'
        />
      </div>

      <div className='grid gap-4 sm:grid-cols-2'>
        <Skeleton.Input
          active
          size='large'
          className='w-full rounded-lg dark:bg-gray-200'
        />
        <Skeleton.Input
          active
          size='large'
          className='w-full rounded-lg dark:bg-gray-200'
        />
      </div>

      {/* Large text area */}
      <Skeleton.Input
        active
        size='large'
        className='w-full h-28 rounded-lg dark:bg-gray-200'
      />

      <div className='grid gap-4 sm:grid-cols-2'>
        <Skeleton.Input
          active
          size='large'
          className='w-full rounded-lg dark:bg-gray-200'
        />
        <Skeleton.Input
          active
          size='large'
          className='w-full rounded-lg dark:bg-gray-200'
        />
      </div>

      {/* Button placeholder aligned right */}
      <div className='flex justify-end'>
        <Skeleton.Button
          active
          size='small'
          className='w-20 rounded-lg dark:bg-gray-200'
        />
      </div>
    </div>
  );
}
